import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import {
  SubNavigation,
  SubNavigationItem,
  Grid,
  Row,
  Col,
  SubNavBottomDivider,
  breakpoint,
} from '@grays-npm/component-library';
import { VendorSelect } from '..';
import { useCMSData } from '../../state/content-manager';

export type NavItem = {
  title: string;
  type: 'Dashboard' | 'Listings' | 'Contract' | 'ResourceCenter' | 'Reports';
  href: string;
  disabled?: boolean;
  hidden?: boolean;
  active?: boolean;
};

const Content = styled(Col)`
  display: flex;
  flex-direction: column-reverse;
  padding: 0 ${({ theme }) => theme.spacings[1].rem};

  ${breakpoint('lg')`
    flex-direction: row;
    justify-content: space-between;
    padding: inherit;
  `}
`;

const Link = styled(NavLink)<{ disabled?: boolean }>`
  ${({ disabled }) => disabled && `pointer-events: none`}
`;

export const AppNavigator: React.FC = () => {
  const cmsData = useCMSData();
  return (
    <>
      <Grid>
        <Row center>
          <Content sm={4} md={8} lg={10}>
            <SubNavigation showDivider={false}>
              {cmsData?.navigation.map(
                (item) =>
                  !item.hidden && (
                    <SubNavigationItem
                      key={item.title}
                      disabled={item.disabled}
                    >
                      <Link disabled={item.disabled} to={item.href}>
                        {item.title}
                      </Link>
                    </SubNavigationItem>
                  )
              )}
            </SubNavigation>
            <VendorSelect />
          </Content>
        </Row>
      </Grid>
      <SubNavBottomDivider />
    </>
  );
};
